import classNames from 'classnames';
import { Heading, LayoutStack } from 'design-system/server';
import { getEmbeddableVideoUrl } from '../../../helpers';
import HeroImage from './HeroImage';
import styles from './HeroSection.module.css';
import HeroVideo from './HeroVideo';
import PublicFace from './PublicFace';
import type { HeroSectionProps } from './types';
function HeroSection({
  backgroundColor,
  heroImage,
  publicFaceImage,
  publicFaceName,
  fundraisingEventName,
  isSponsored,
  heroVideo,
  headerImageUrl,
  publicFaceId
}: HeroSectionProps) {
  const heroVideoUrl = heroVideo && getEmbeddableVideoUrl(heroVideo);
  return <LayoutStack className={styles.container} space="300" as="div">
      <section style={{
      background: headerImageUrl ? `url(${headerImageUrl})` : 'unset',
      backgroundColor: backgroundColor ? `#${backgroundColor}` : 'unset'
    }} className={classNames(styles.headerContainer, {
      [styles.headerBackground!]: headerImageUrl
    })} data-testid="hero-image-container">
        {heroVideoUrl ? <HeroVideo videoUrl={heroVideoUrl} /> : <HeroImage image={heroImage} />}
      </section>
      <PublicFace name={publicFaceName} image={publicFaceImage} isSponsored={isSponsored} id={publicFaceId} />
      <Heading as="h1" level="heading-md" className={styles.heading}>
        {fundraisingEventName}
      </Heading>
    </LayoutStack>;
}
export default HeroSection;